import { render, staticRenderFns } from "./add-shows.vue?vue&type=template&id=2fd1eaaf"
import script from "./add-shows.vue?vue&type=script&lang=js"
export * from "./add-shows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports